export const RightSignatureLocalEnv = {
	// RIGHTSIGNATURE_BASE_URL: 'https://api.rs.localhost:3002',
	RIGHTSIGNATURE_BASE_URL: 'https://localhost:48218',
	// RS4_CLIENT_ID: 'EroVbL7cQ4bBCZIqtuP8AChiy3HIUXMf',
	RS4_CLIENT_ID: 'PvLxGCnWJglVNCGm7jGjYT4c5kb94l2p',
	RIGHTSIGNATURE_S3_BUCKET_URL: 'https://rightsign-development.s3.amazonaws.com/',
};
